"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "sidebarCtrl",
    function (permissionService, settings) {
      var vm = this;
      vm.settings = settings;

      vm.menu = [];
      vm.permissions = permissionService;

      vm.groups = window.enumerators.enumGroupsColorsRequests;

      vm.isDesigner = function() { return vm.settings.isColorsUserGroupByName('Designer') };
      vm.isVendedor = function() { return vm.settings.isColorsUserGroupByName('VendedorBalcao'); };
      vm.isControleQualidade = function() { return vm.settings.isColorsUserGroupByName('ControleQualidade'); };

      vm.menu.push(
        /*{
    name: 'global.menu.reports',
    icon: 'description',
    task: 'ControlPanelAccess',
    submenu: [
      { name: 'reports.users.title', path: 'main.reports', task: 'ManageUsers' }
    ]
    },*/

        {
          name: "Gerenciamento",
          icon: "settings",
          task: "ControlPanelAccess",
          submenu: [
            {
              name: "Meu Perfil",
              path: "/#!/user/passwordchange",
              task: "ControlPanelAccess",
            },
            { name: "Usuários", path: "/#!/user", task: "AdminAccess" },
            { name: "Clientes", path: "/#!/customer", task: "AdminAccess" },
            //{ name: 'goals.settings.title', path: 'main.goal', task: 'ManageGoals' },
          ],
        },
        {
          // name: 'Manual SWFLOW',
          // icon: 'description',
          // task: 'ControlPanelAccess',
          // submenu: [
          // 	{ name: 'Apresentação', path: '/Content/documents/ApresentacaoManualVendasCooperadasSWFlow.pdf', task: 'ControlPanelAccess', blank: true },
          // 	{ name: 'Manual', path: '/Content/documents/ManualVendasCooperadasSWFlow.pdf', task: 'ControlPanelAccess', blank: true }
          // ]
        }
      );

      // Só pode aparecer Cores para os usuários que tenham perfil do Cores
      if (config.projectModule == "Colors") {
        vm.menu.unshift({
          name: "Cores",
          icon: "palette",
          task: "ControlPanelAccess",
          submenu: [
            {
              name: "Dashboard",
              path: "/#!/dashboardcolors",
              task: "ManageColorsRequests",
            },
            {
              name: "Solicitações",
              path: "/#!/colorrequest",
              task: "ManageColorsRequests",
            },
            vm.isDesigner() ? {
              name: "Manual",
              path: "/Content/documents/ManualASuaCorDesignerV3.pdf",
              task: "ManageColorsRequests",
              blank: true,
            } : vm.isVendedor() ? {
              name: "Manual",
              path: "/Content/documents/ManualASuaCor_Vendedores_V3.pdf",
              task: "ManageColorsRequests",
              blank: true,
            } : vm.isControleQualidade() ? {
              name: "Manual do Vendedor",
              path: "/Content/documents/ManualASuaCor_Vendedores_V3.pdf",
              task: "ManageColorsRequests",
              blank: true,
            } : null,
          ],
        });
      }

      // Não pode aparecer ações para os usuários que tenham perfil do Cores
      if (config.projectModule != "Colors") {
        vm.menu.unshift(
          {
            name: "Ações",
            icon: "star_rate",
            task: "ControlPanelAccess",
            submenu: [
              // { name: 'accessLogs.settings.title', path: 'main.acceslog', task: 'ManageAccessLogs' },
              // { name: 'attachments.settings.title', path: 'main.attachment', task: 'ManageAttachments' },
              // { name: 'attachmentTypes.settings.title', path: 'main.attachmenttype', task: 'ManageAttachmentTypes' },
              // { name: 'customersSalesUserHistoric.settings.title', path: 'main.customersaleuserhistoric', task: 'ManageCustomersSalesUserHistoric' },
              // { name: 'disapprovalReasons.settings.title', path: 'main.disapprovalreason', task: 'ManageDisapprovalReasons' },
              {
                name: "Dashboard",
                path: "/#!/dashboard",
                task: "ViewMarketingDashboard",
              },
              {
                name: "Solicitações",
                path: "/#!/promotionrequest",
                task: "ManagePromotionRequests",
              },
              {
                name: "Apresentação",
                path: "/Content/documents/ApresentacaoManualVendasCooperadasSWFlow.pdf",
                task: "ControlPanelAccess",
                blank: true,
              },
              {
                name: "Manual",
                path: "/Content/documents/ManualVendasCooperadasSWFlow.pdf",
                task: "ControlPanelAccess",
                blank: true,
              },
              {
                name: "Mecânica",
                path: "/Content/documents/Mecanica.pdf",
                task: "ControlPanelAccess",
                blank: true,
              },
              {
                name: "Checklist",
                path: "/Content/documents/CheckList.pdf",
                task: "ControlPanelAccess",
                blank: true,
              },
              // { name: 'promotionRequestsGoals.settings.title', path: 'main.promotionrequestgoal', task: 'ManagePromotionRequestsGoals' },
              // { name: 'promotionRequestsProductSegments.settings.title', path: 'main.promotionrequestproductsegment', task: 'ManagePromotionRequestsProductSegments' },
              // { name: 'promotionRequestTypes.settings.title', path: 'main.promotionrequesttype', task: 'ManagePromotionRequestTypes' },
              // { name: 'status.settings.title', path: 'main.statu', task: 'ManageStatus' },
              // { name: 'statusGroups.settings.title', path: 'main.statugroup', task: 'ManageStatusGroups' },
              // { name: 'workflowApprovals.settings.title', path: 'main.workflowapproval', task: 'ManageWorkflowApprovals' },
              // { name: 'workflows.settings.title', path: 'main.workflow', task: 'ManageWorkflows' },
            ],
          },
          {
            name: "Bonificações e Patrocínios",
            icon: "thumb_up_off",
            task: "BonusesAndSponsorshipsAccess",
            submenu: [
              {
                name: "Dashboard",
                path: "/#!/bonusesandsponsorship-dashboard",
                task: "BonusesAndSponsorshipsApprover",
              },
              {
                name: "Solicitações",
                path: "/#!/bonusesandsponsorship",
                task: "BonusesAndSponsorshipsAccess",
              },
            ],
          }
        );
      }

      vm.toggleSubmenu = function (item) {
        item.toggle = !item.toggle;
      };
    }
  );
